import { Button, Container, Stack, Text, Title } from '@mantine/core'
import { Link } from '@tanstack/react-router'

export interface RouteMessageProps {
  readonly title: string
  readonly description: string
  /** Omit for messages that are not dead ends. */
  readonly backToQueue?: boolean
}

/**
 * The shared shape for a whole-route message: not-found, not-authorized, and
 * (from stage 3) "this job is no longer available" — docs/spec/04 §7.
 *
 * These are first-class states, not fallbacks (07 §2). Every one of them offers
 * a way onward: a staff user who hits a wall mid-shift needs a route back to
 * work, not an apology.
 */
export function RouteMessage({ title, description, backToQueue = true }: RouteMessageProps) {
  return (
    <Container size="sm" py="xl">
      <Stack gap="sm" align="flex-start">
        <Title order={1} size="h3">
          {title}
        </Title>
        <Text c="dimmed">{description}</Text>
        {backToQueue && (
          <Button component={Link} to="/queue" variant="light" mt="sm">
            Back to the queue
          </Button>
        )}
      </Stack>
    </Container>
  )
}
